/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { saveActionLog } from 'lib/requestLog'
import PortalContainer from 'containers/PortalContainer'

const styles = theme => ({
  logoWrap: {
    marginTop: '2em'
  },
  logoImg: {
    width: 120
  },
  errorWrap: {
    minHeight: '80vh',
    textAlign: 'center',
    padding: '1em',
    backgroundColor: theme.palette.background.default
  },
  errorTitle: {
    marginBottom: theme.spacing(3)
  },
  btnArea: {
    marginTop: '1em'
  },
  link: {
    textDecoration: 'none'
  }
})

const NotFound = props => {
  saveActionLog({
    actionName: 'NotFoundPageRender',
    event: { label: window.location.pathname },
    data: { href: window.location.href }
  })
  return <PortalContainer {...props} />
}

export default withStyles(styles)(NotFound)
